import { useSelector } from 'react-redux';

import { selectUserProjectTimeZone } from 'core/userContext';
import { selectProjectId } from 'modules/campaignAnalytics';
import {
  GenerateUpdateCampaignPayloadOptions,
  UpdatedCampaignFields,
  UpdateCampaignPayload,
} from './types';
import { GraphQLCampaign } from '../../types';

export const useGenerateSaveCampaignPayload = (
  payloadCreator: (
    campaign: GraphQLCampaign,
    updateFields: Partial<UpdatedCampaignFields>,
    options: GenerateUpdateCampaignPayloadOptions,
  ) => UpdateCampaignPayload,
) => {
  const projectId = useSelector(selectProjectId);
  const projectTimeZone = useSelector(selectUserProjectTimeZone);

  return (campaign: GraphQLCampaign, updateFields: Partial<UpdatedCampaignFields>) => {
    return payloadCreator(campaign, updateFields, { projectId, projectTimeZone });
  };
};
